import { render, staticRenderFns } from "./InpatientCharts.vue?vue&type=template&id=559fbc98&"
import script from "./InpatientCharts.vue?vue&type=script&lang=js&"
export * from "./InpatientCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports